<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.ha_code }}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="ha_yearmonth">
            <label class="weui-form-preview__label">{{customLabel.ha_yearmonth || "月份"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.ha_yearmonth
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="ha_workday">
            <label class="weui-form-preview__label">{{customLabel.ha_workday || "开工天数"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.ha_workday }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="ha_attendance">
            <label class="weui-form-preview__label">{{customLabel.ha_attendance || "应出勤人数"}}</label>
            <span
              class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ form.main.ha_attendance }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="ha_actual">
            <label class="weui-form-preview__label">{{customLabel.ha_actual || "实际出勤人数"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.ha_actual }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="ha_leave">
            <label class="weui-form-preview__label">{{customLabel.ha_leave || "请假人数"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.ha_leave }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="ha_ot">
            <label class="weui-form-preview__label">{{customLabel.ha_ot || "工作日加班工时"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.ha_ot }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="ha_rest_ot">
            <label class="weui-form-preview__label">{{customLabel.ha_rest_ot || "休息日加班工时"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.ha_rest_ot }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="ha_holiday_ot">
            <label class="weui-form-preview__label">{{customLabel.ha_holiday_ot || "节假日加班工时"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.ha_holiday_ot }}
              </span>
          </div>
          <div class="weui-form-preview__item" slot="ha_ot_count">
            <label class="weui-form-preview__label">{{customLabel.ha_ot_count || "加班总时长"}}</label>
            <span class="weui-form-preview__value"
              >{{ form.main.ha_ot_count }}
              </span>
          </div>
        </custom-layout>
      </div>
      <!-- <custom-layout class="form-preview weui-form-preview" :view-config="customViewConfig">
        <div class="weui-form-preview__bd" slot="ac_agentname">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">{{customLabel.ac_agentname || "代理商名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.ac_agentname
            }}</span>
          </div>
        </div>
      </custom-layout> -->
      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="(item, index) in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ index }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="had_emcode">
              <label class="weui-form-preview__label">{{customLabel.had_emcode || "工号"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.had_emcode }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="had_emname">
              <label class="weui-form-preview__label">{{customLabel.had_emname || "姓名"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.had_emname }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="had_deptname">
              <label class="weui-form-preview__label">{{customLabel.had_deptname || "部门"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.had_deptname }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="had_cr_code">
              <label class="weui-form-preview__label">{{customLabel.had_cr_code || "所属规则"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.had_cr_code }}
              </span>
            </div>
            <div class="weui-form-preview__item" slot="had_cr_name">
              <label class="weui-form-preview__label">{{customLabel.had_cr_name || "所属规则名称"}}</label>
              <span class="weui-form-preview__value weui-form-preview__value-icon"
                >{{ item.had_cr_name }}
              </span>
            </div>
            <template v-if="index == showIndex">
              <div class="weui-form-preview__item" slot="had_ex_job">
                <label class="weui-form-preview__label">{{customLabel.had_ex_job || "职务"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_ex_job }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_workday">
                <label class="weui-form-preview__label">{{customLabel.had_workday || "开工天数"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_workday }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_should_workday">
                <label class="weui-form-preview__label">{{customLabel.had_should_workday || "应出勤天数"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_should_workday }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_day_standa_time">
                <label class="weui-form-preview__label">{{customLabel.had_day_standa_time || "日标准工作时长（H）"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_day_standa_time }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_standa_time">
                <label class="weui-form-preview__label">{{customLabel.had_standa_time || "月标准工作时长（H）"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_standa_time }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_actual_time">
                <label class="weui-form-preview__label">{{customLabel.had_actual_time || "实际工作时长（H）"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_actual_time }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_ot_time">
                <label class="weui-form-preview__label">{{customLabel.had_ot_time || "加班时长"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_ot_time }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_ot_exchange">
                <label class="weui-form-preview__label">{{customLabel.had_ot_exchange || "工作日加班(调休)"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_ot_exchange }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_ot_pay">
                <label class="weui-form-preview__label">{{customLabel.had_ot_pay || "工作日加班(加班费)"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_ot_pay }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_rest_ot_exchange">
                <label class="weui-form-preview__label">{{customLabel.had_rest_ot_exchange || "休息日加班(调休)"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_rest_ot_exchange }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_rest_ot_pay">
                <label class="weui-form-preview__label">{{customLabel.had_rest_ot_pay || "休息日加班(加班费)"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_rest_ot_pay }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_holiday_ot_exchange">
                <label class="weui-form-preview__label">{{customLabel.had_holiday_ot_exchange || "节假日加班(调休)"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_holiday_ot_exchange }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_holiday_ot_pay">
                <label class="weui-form-preview__label">{{customLabel.had_holiday_ot_pay || "节假日加班(加班费)"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_holiday_ot_pay }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_absenteeism_time">
                <label class="weui-form-preview__label">{{customLabel.had_absenteeism_time || "旷工（天）"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_absenteeism_time }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_late_time">
                <label class="weui-form-preview__label">{{customLabel.had_late_time || "迟到（分钟）"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_late_time }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_late_count">
                <label class="weui-form-preview__label">{{customLabel.had_late_count || "迟到（次数）"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_late_count }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_leave_early_time">
                <label class="weui-form-preview__label">{{customLabel.had_leave_early_time || "早退（分钟）"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_leave_early_time }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_leave_early_count">
                <label class="weui-form-preview__label">{{customLabel.had_leave_early_count || "早退（次数）"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_leave_early_count }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_annual_hour">
                <label class="weui-form-preview__label">{{customLabel.had_annual_hour || "年假（小时）"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_annual_hour }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_matter_hour">
                <label class="weui-form-preview__label">{{customLabel.had_matter_hour || "事假（小时）"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_matter_hour }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_sick_hour">
                <label class="weui-form-preview__label">{{customLabel.had_sick_hour || "病假（小时）"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_sick_hour }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_exchange_hour">
                <label class="weui-form-preview__label">{{customLabel.had_exchange_hour || "调休假（小时）"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_exchange_hour }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_marry_hour">
                <label class="weui-form-preview__label">{{customLabel.had_marry_hour || "婚假（小时）"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_marry_hour }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_maternity_hour">
                <label class="weui-form-preview__label">{{customLabel.had_maternity_hour || "产假（小时）"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_maternity_hour }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_paternity_hour">
                <label class="weui-form-preview__label">{{customLabel.had_paternity_hour || "陪产假（小时）"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_paternity_hour }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_other_day">
                <label class="weui-form-preview__label">{{customLabel.had_other_day || "其他（天）"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_other_day }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_funeral_hour">
                <label class="weui-form-preview__label">{{customLabel.had_funeral_hour || "丧假（小时）"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_funeral_hour }}
                </span>
              </div>
              <div class="weui-form-preview__item" slot="had_newyear_hour">
                <label class="weui-form-preview__label">{{customLabel.had_newyear_hour || "春节必休（小时）"}}</label>
                <span class="weui-form-preview__value weui-form-preview__value-icon"
                  >{{ item.had_newyear_hour }}
                </span>
              </div>
            </template>
          </custom-layout>
          <div class="weui-form-preview__item" :key="index">
            <!-- <label class="weui-form-preview__label">{{"操作"}}</label> -->
            <span class="weui-form-preview__value weui-form-preview__value-icon">
              <i class="iconfont icon-shang" v-if="index == showIndex" @click="showIndex = -1"></i>
              <i class="iconfont icon-xia" v-else @click="showIndex = index"></i>
              <router-link
                class="iconfont icon-eye"
                :to="{
                  path: '/oa/attendance_day_list',
                  query: { had_emid: item.had_emid},
                }"
              ></router-link>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import process from "@/mixins/process.js";

export default {
  components: {
    CustomLayout
  },
  mixins: [process],
  data() {
    return {
      baseUrl: "/api/hr/hrAttendance",
      codeField: "ha_code",
      statusField: "ha_statuscode",
      caller: "hrAttendance",
      xtype:'hr-attendance-formpanel',
      showIndex: -1
    };
  }
}
</script>